<template>
  <v-layout class="px-3" column justify-start align-center fill-height style="margin-top: 80px">
    <div class="width-100">
      <v-fade-transition>
        <v-layout justify-center v-if="ready">
          <v-card class="rounded-5" width="100%" max-width="500px">
            <v-card-title class="justify-center font-weight-black">회원가입</v-card-title>

            <v-card-text>
              <v-form @submit.prevent="signup(user)">
                <v-text-field
                  v-model="user.email"
                  label="이메일"
                  outlined
                  dense
                  :error="!!invalidMsg.email"
                  :rules="rules.email"
                  autofocus
                  autocomplete="email"
                ></v-text-field>
                <v-text-field
                  type="password"
                  v-model="user.password"
                  label="비밀번호"
                  outlined
                  dense
                  :error="!!invalidMsg.password"
                  :rules="rules.password"
                  autocomplete="new-password"
                ></v-text-field>
                <v-text-field
                  type="password"
                  v-model="user.rePassword"
                  label="비밀번호 확인"
                  outlined
                  dense
                  :error="!!invalidMsg.rePassword"
                  :rules="rules.rePassword"
                  autocomplete="new-password"
                  ref="rePassword"
                ></v-text-field>
                <v-text-field
                  v-model="user.phone"
                  label="휴대폰 번호"
                  outlined
                  dense
                  :error="!!invalidMsg.phone"
                  :rules="rules.phone"
                  autocomplete="tel"
                ></v-text-field>
                <BasicButton
                  type="submit"
                  block
                  depressed
                  height="46"
                  :disabled="signupLoading || !isValidAll"
                  :loading="signupLoading"
                >
                  회원가입
                </BasicButton>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-layout justify-space-between align-center>
                <span class="font--m-5 color--nice-grey">이미 계정이 있으신가요?</span>
                <v-btn :to="{ name: 'signin' }" color="primary" class="px-0" depressed text>
                  로그인
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-fade-transition>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getRedirectUriAndRemove, sleep } from '@/util'
import Regex from '@/const/Regex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        rePassword: '',
        phone: '',
      },
      signupLoading: false,
      invalidMsg: {
        email: null,
        password: null,
        rePassword: null,
        phone: null,
      },
      rules: {
        email: [
          (value) => !!value || '메일 주소를 입력해주세요.',
          (value) => Regex.EMAIL.REGEX.test(value) || Regex.EMAIL.MSG,
        ],
        password: [
          (value) => !!value || '패스워드를 입력해주세요',
          (value) => value.length > 5 || '6자 이상 입력해주세요',
        ],
        rePassword: [
          (value) => !!value || '패스워드를 입력해주세요',
          (value) => {
            return value === this.user.password || '비밀번호가 일치하지 않습니다.'
          },
        ],
        phone: [
          (value) => !!value || '휴대폰 번호를 입력해주세요.',
          (value) => Regex.PHONE.REGEX.test(value) || Regex.PHONE.MSG,
        ],
      },
      emailIsValid: false,
      passwordIsValid: false,
      rePasswordIsValid: false,
      phoneIsValid: false,
      ready: false,
    }
  },
  async mounted() {
    await sleep(200)
    this.ready = true
  },
  computed: {
    isValidAll() {
      return (
        this.emailIsValid && this.passwordIsValid && this.rePasswordIsValid && this.phoneIsValid
      )
    },
  },
  watch: {
    'user.email'(email) {
      this.emailValidate(email)
    },
    'user.password'(password) {
      this.passwordValidate(password)
      this.rePasswordValidate(this.user.rePassword)
    },
    'user.rePassword'(rePassword) {
      this.rePasswordValidate(rePassword)
    },
    'user.phone'(phone) {
      this.phoneValidate(phone)
    },
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['addIdPasswordUser']),
    ...mapActions('myfinbiz', ['organizationsAddCustomer']),
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    emailValidate(email) {
      const msg = this.getFormErrMsg('email', email)
      if (msg === null) {
        this.emailIsValid = true
      } else {
        this.emailIsValid = false
      }
    },
    passwordValidate(password) {
      const msg = this.getFormErrMsg('password', password)
      if (msg === null) {
        this.passwordIsValid = true
      } else {
        this.passwordIsValid = false
      }
      this.$refs.rePassword.validate()
    },
    rePasswordValidate(rePassword) {
      const msg = this.getFormErrMsg('rePassword', rePassword)
      if (msg === null) {
        this.rePasswordIsValid = true
      } else {
        this.rePasswordIsValid = false
      }
    },
    phoneValidate(phone) {
      const msg = this.getFormErrMsg('phone', phone)
      if (msg === null) {
        this.phoneIsValid = true
      } else {
        this.phoneIsValid = false
      }
    },
    async movePage() {
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/'
      }
      if (await redirectSignupManage()) {
        return
      }
      await this.$router.replace(redirectUri)
    },
    async signup(user) {
      try {
        this.signupLoading = true
        await this.addIdPasswordUser({
          email: user.email,
          password1: user.password,
          password2: user.rePassword,
          phone: user.phone,
        })
        try {
          await this.organizationsAddCustomer()
        } catch (e) {
          console.log(e)
        }
        await this.movePage()
      } catch (e) {
        if (e.status === 400) {
          this.user.password = ''
        }
        throw e
      } finally {
        this.signupLoading = false
      }
    },
  },
}
</script>
